import React, { FC } from 'react';
import { Link as RouteLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faEnvelope, faLock, faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import { pages } from '../Constants/Pages';
import { Alert, Heading, Link, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

enum Service {
	Unknown = 0,
	TVService = 1,
	Fsecure = 2,
	EmailAccountManagement = 3,
	BroadbandManagement = 4
}

export const ServiceLinks: FC<{ customerServices: number[] }> = (props) => {
	const { t } = useTranslation(['common', 'calendar']);

	const tvAndSecurity =
		props.customerServices.includes(Service.TVService) ||
		props.customerServices.includes(Service.Fsecure);

	return (
		<>
			<Heading as="h3" fontSize="lg" my={4}>
				{t('SERVICE_LIST_HEADING')}:
			</Heading>

			<section>
				{props.customerServices.includes(Service.EmailAccountManagement) && (
					<Link as={RouteLink} to={pages.emailService} {...linkProps}>
						<Text color="blue.300" as="span">
							<FontAwesomeIcon icon={faEnvelope} />
						</Text>
						<Text ml={3} as="span">
							{t('LINK_EMAIL_SERVICE')}
						</Text>
					</Link>
				)}

				{props.customerServices.includes(Service.BroadbandManagement) && (
					// <Link as={RouteLink} to={pages.broadbandList} {...linkProps}>
					// 	<Text color="blue.300" as="span">
					// 		<FontAwesomeIcon icon={faHome} />
					// 	</Text>
					// 	<Text ml={3} as="span">
					// 		{t('LINK_MOKKI_SCHEDULING')}
					// 	</Text>
					// </Link>
					<Alert status="warning">
						Portaalissa on huoltokatko. Mikäli haluat muutoksen liittymääsi ole yhteydessä
						asiakaspalvelu@blc.fi.
					</Alert>
				)}

				{tvAndSecurity && (
					<Link as={RouteLink} to={pages.TvAndSecurity} {...linkProps}>
						<Text color="blue.300" as="span">
							<FontAwesomeIcon icon={faLock} />
						</Text>
						<Text ml={3} as="span">
							{t('LINK_TV_AND_SECURITY')}
						</Text>
					</Link>
				)}

				{/* <Link as={RouteLink} to={pages.change_password} {...linkProps}>
					<Text color="blue.300" as="span">
						<FontAwesomeIcon icon={faShieldAlt} />
					</Text>
					<Text ml={3} as="span">
						{t('calendar:CHANGE_PASSWORD_PAGE_TITLE')}
					</Text>
				</Link> */}
			</section>
		</>
	);
};

const linkProps = {
	borderRadius: 22,
	d: 'block',
	py: 3,
	px: 6,
	mt: 2,
	bg: 'blue.50',
	_hover: {
		bg: 'blue.100'
	}
};
